import { FunctionComponent } from "react";
import { Event } from "@dto/Event";
import { ActionBar } from "@ui-kit/ActionBar/ActionBar";
import { PhoneActionButton } from "../entities/shared/PhoneActionButton/PhoneActionButton";
import { WebsiteActionButton } from "../entities/shared/WebsiteActionButton/WebsiteActionButton";

interface EventActionButtonsProps {
  event: Event;
}

const EventActionButtons: FunctionComponent<EventActionButtonsProps> = ({
  event,
}) => {
  return (
    <ActionBar>
      {event.phoneNumber && (
        <PhoneActionButton phoneNumber={event.phoneNumber} entity={event} />
      )}
      {event.website && (
        <WebsiteActionButton website={event.website} entity={event} />
      )}
    </ActionBar>
  );
};

export { EventActionButtons };
